import {BACKEND_API} from '../middleware/backend'

export const SESSION_INFO_REQUEST = 'SESSION_INFO_REQUEST';
export const SESSION_INFO_SUCCESS = 'SESSION_INFO_SUCCESS';
export const SESSION_INFO_FAILURE = 'SESSION_INFO_FAILURE';
export const SESSION_LOGIN_REQUEST = 'SESSION_LOGIN_REQUEST';
export const SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
export const SESSION_LOGIN_FAILURE = 'SESSION_LOGIN_FAILURE';
export const SESSION_LOGOUT_REQUEST = 'SESSION_LOGOUT_REQUEST';
export const SESSION_LOGOUT_SUCCESS = 'SESSION_LOGOUT_SUCCESS';
export const SESSION_LOGOUT_FAILURE = 'SESSION_LOGOUT_FAILURE';

export const SESSION_CHANGE_PASSWORD_REQUEST = 'SESSION_CHANGE_PASSWORD_REQUEST';
export const SESSION_CHANGE_PASSWORD_SUCCESS = 'SESSION_CHANGE_PASSWORD_SUCCESS';
export const SESSION_CHANGE_PASSWORD_FAILURE = 'SESSION_CHANGE_PASSWORD_FAILURE';

export const SESSION_FORGOTTEN_PASSWORD_REQUEST = 'SESSION_FORGOTTEN_PASSWORD_REQUEST';
export const SESSION_FORGOTTEN_PASSWORD_SUCCESS = 'SESSION_FORGOTTEN_PASSWORD_SUCCESS';
export const SESSION_FORGOTTEN_PASSWORD_FAILURE = 'SESSION_FORGOTTEN_PASSWORD_FAILURE';

export const sessionInfo = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SESSION_INFO_REQUEST, SESSION_INFO_SUCCESS, SESSION_INFO_FAILURE],
			endpoint: 'auth/info',
			silent: true
		}
	})
};

export const sessionLogin = (email, password, rememberMe) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SESSION_LOGIN_REQUEST, SESSION_LOGIN_SUCCESS, SESSION_LOGIN_FAILURE],
			endpoint: 'auth/login',
			body: {email, password, rememberMe},
			silent: true
		}
	})
};

export const sessionLogout = () => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SESSION_LOGOUT_REQUEST, SESSION_LOGOUT_SUCCESS, SESSION_LOGOUT_FAILURE],
			endpoint: 'auth/logout'
		}
	})
};

export const changePassword = (email, password, token) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SESSION_CHANGE_PASSWORD_REQUEST, SESSION_CHANGE_PASSWORD_SUCCESS, SESSION_CHANGE_PASSWORD_FAILURE],
			endpoint: 'auth/change-password',
			body: {email, password, token},
			silent: true
		}
	})
};

export const forgottenPassword = (email, silent = true) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [SESSION_FORGOTTEN_PASSWORD_REQUEST, SESSION_FORGOTTEN_PASSWORD_SUCCESS, SESSION_FORGOTTEN_PASSWORD_FAILURE],
			endpoint: 'auth/forgotten-password',
			body: {email},
			silent: silent
		}
	})
};


// WEBPACK FOOTER //
// ./src/actions/session.js